import { RouteNames } from "@/RouteNames";
import { translateFunc } from "@/utils/translateFunc";
import Link from "components/common/Link";
import { useRouter } from "next/router";

export const DesktopLoginNavLink = () => {
    const router = useRouter();

    const getRedirectUrl = (): string => {
        if (router.pathname === RouteNames.loginRoute || router.pathname === RouteNames.signupRoute) {
            return RouteNames.loginRoute;
        }

        if (router.pathname === "/") {
            return router.locale === "en"
                ? `${RouteNames.loginRoute}?redirect=/en/`
                : `${RouteNames.loginRoute}?redirect=/`;
        }
        return `${RouteNames.loginRoute}?redirect=${router.asPath}`;
    };
    return (
        <div className="ml-3 flex gap-6 items-center [body[data-is-logged-in=true]_&]:hidden">
            <Link
                href={getRedirectUrl()}
                className="border-[1px] border-gray-300 dark:border-white dark:text-white rounded-md px-4 py-1 capitalize whitespace-nowrap"
                data-automation-id="loginButton"
            >
                {translateFunc("common:login")}
            </Link>
            <Link
                href={RouteNames.pricing}
                className="border-[1px] bg-irBlue-600 border-irBlue-600 text-white rounded-md px-4 py-1 capitalize whitespace-nowrap"
                data-automation-id="signupButton"
            >
                {translateFunc("common:signup")}
            </Link>
        </div>
    );
};
